export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g stroke="#2D3139" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.553 1.709v2.163a2.734 2.734 0 0 0 2.735 2.735h2.399" />
      <path d="M8.382 6.379c.455-.042.943-.062 1.468-.062.731 0 1.398.041 1.992.122l4.61 4.39c.154.854.227 1.854.227 3.009 0 1.055-.06 1.98-.19 2.784M8.381 6.379c-3.979.365-5.354 2.402-5.354 7.459 0 5.642 1.708 7.52 6.822 7.52 4.163 0 6.07-1.24 6.638-4.736M8.382 6.379c.568-3.49 2.475-4.736 6.63-4.736.732 0 1.399.04 1.992.122l4.61 4.39c.155.854.228 1.854.228 3.008 0 5.061-1.374 7.094-5.354 7.459" />
      <path d="M11.39 6.383v2.163a2.734 2.734 0 0 0 2.735 2.735h2.399" />
    </g>
  </svg>
);
